var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2926",
    fillRule: "evenodd",
    d: "M22.331.7C23.251.7 24 1.442 24 2.352v14.696c0 .91-.75 1.652-1.669 1.652H1.67C.749 18.7 0 17.958 0 17.048V2.352C0 1.442.75.7 1.669.7ZM1.43 2.917v14.131a.24.24 0 0 0 .239.236H22.33a.24.24 0 0 0 .238-.236V3.012l-10.174 7.45a.71.71 0 0 1-.828.01l-.02-.014zm19.942-.802H2.748l9.23 6.88z"
  })));
};
export default SvgMail;